module.exports = __webpack_public_path__ + "static/media/homeframe.22ee7af9.png";